import "../../chunk-7QVYU63E.js";
import { TeamRole } from "#rbac/teamRole.js";
import { z } from "zod";
const UserSchema = z.object({
  id: z.number(),
  extId: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  teamId: z.number().nullish(),
  isActive: z.boolean(),
  isStaff: z.boolean(),
  isBillingAdmin: z.boolean(),
  teamRole: z.nativeEnum(TeamRole).nullish().or(z.string().transform(() => void 0)),
  role: z.string(),
  telegramUsername: z.string(),
  discordUsername: z.string(),
  hasJoinedDiscord: z.boolean(),
  lastActive: z.string().optional(),
  acceptedInvite: z.boolean().default(false),
  createdAt: z.string(),
  referralType: z.string().nullish(),
  referredBy: z.string().nullish()
});
export {
  UserSchema
};
//# sourceMappingURL=users.js.map